var React = require('react');

function MinusCircle (props) {
    return React.createElement("symbol",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 3.002a8.998 8.998 0 1 0 0 17.996 8.998 8.998 0 0 0 0-17.996zM.998 12C.998 5.924 5.924.998 12 .998 18.076.998 23 5.924 23 12c0 6.076-4.925 11.002-11.001 11.002S.998 18.076.998 12zM16 10.998a1.002 1.002 0 0 1 0 2.004H8a1.002 1.002 0 0 1 0-2.004h8z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"d":"M0 5a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v14a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5z"})))]);
}

MinusCircle.displayName = "MinusCircle";

MinusCircle.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = MinusCircle;

MinusCircle.default = MinusCircle;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/minus-circle.svg
// module id = 1278
// module chunks = 0